module.exports = __webpack_public_path__ + "static/media/time_workflow.c5951d64.png";